import React, { useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import getConfig from 'next/config';
import EirActionModal from '../eir-action-modal/EirActionModal';
import RootContext from '../../../util/root.context';
import { setCode } from '../../hooks/useLocalStorage';
import fetchInfo from '../../../util/fetchModalData';

const { publicRuntimeConfig } = getConfig();

const EirAddSimhandsetModal = ({ openAccountCheck, localStore, journeyData }) => {
  const router = useRouter();
  const { dispatch } = useContext(RootContext);

  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);

  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'MW-add_another_eirMobile',
      });
      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };
  useEffect(() => {
    getCmsData();
  }, []);

  useEffect(() => {
    if (journeyData?.cartType === 'CROSS_SELL') {
      setCode('CS');
    }
    if (journeyData?.cartType === 'CHANGE_OFFER') {
      setCode('CO');
    }
    if (localStore.hasValue('PORTIN')) {
      localStore.removeLocalStorage('PORTIN');
    }
  }, []);
  const handleYes = async () => {
    localStore.setLocalStorage('ENABLE_MULTI_OFFERS', true);
    localStore.setLocalStorage('ADDITIONAL_OFFERS_NEEDED', false);
    dispatch({ type: 'SET_BILLPAY_TOGGLE', payload: false });
    router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile`);
    openAccountCheck.disable();
  };

  const handleNo = async () => {
    localStore.setLocalStorage('ENABLE_MULTI_OFFERS', true);
    localStore.setLocalStorage('ADDITIONAL_OFFERS_NEEDED', false);
    localStore.setLocalStorage('BILLPAY_JOURNEY', true);
    dispatch({ type: 'SET_BILLPAY_TOGGLE', payload: true });
    router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/mobile`);
    openAccountCheck.disable();
  };

  const handleAltCta = async () => {
    localStore.setLocalStorage('ENABLE_MULTI_OFFERS', false);
    localStore.setLocalStorage('ADDITIONAL_OFFERS_NEEDED', false);
    dispatch({ type: 'SET_BILLPAY_TOGGLE', payload: false });
    openAccountCheck.disable();
  };

  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID}
      open={openAccountCheck.value}
      handleClose={openAccountCheck.disable}
      desktopImageSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI_SERVER}${cmsCollectionData?.attributes?.desktopImage?.data?.attributes?.url}`}
      mobileImageSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI_SERVER}${cmsCollectionData?.attributes?.mobileImage?.data?.attributes?.url}`}
      desktopCurveImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.desktopCurveImg?.data?.attributes?.url}`}
      mobileCurverImg={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${cmsCollectionData?.attributes?.mobileCurverImg?.data?.attributes?.url}`}
      desktopCurveImgAlt='desktopCurve'
      mobileCurverImgAlt='mobileCurve'
      desktopImageAlt={
        cmsCollectionData?.attributes?.desktopImage?.data?.attributes?.alternativeText
      }
      mobileImageAlt={cmsCollectionData?.attributes?.mobileImage?.data?.attributes?.alternativeText}
      title={cmsCollectionData?.attributes?.title}
      description={`${
        cmsCollectionData?.attributes?.firstHalfDescription
          ? cmsCollectionData?.attributes?.firstHalfDescription
          : ''
      }
      ${
        cmsCollectionData?.attributes?.secondHalfDescription
          ? cmsCollectionData?.attributes?.secondHalfDescription
          : ''
      }
      `}
      cta={[
        {
          // text: 'SIM Only',
          text: cmsCollectionData?.attributes?.cta[0]?.name
            ? cmsCollectionData?.attributes?.cta[0]?.name
            : 'SIM Only',
          type: 'contained',
          action: () => handleYes(),
          ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            : '',
        },
        {
          // text: 'Bill Pay Phones',
          text: cmsCollectionData?.attributes?.cta[1]?.name
            ? cmsCollectionData?.attributes?.cta[1]?.name
            : 'Bill Pay Phones',
          type: 'contained',
          action: () => handleNo(),
          ariaLabel: cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[1]?.ariaLabel
            : '',
        },
      ]}
      altcta={[{ text: 'No, go to checkout', subText: '»', action: () => handleAltCta() }]}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      load={load}
    />
    // <EirActionModal
    //   id='Modal_AddMobile'
    //   open={openAccountCheck.value}
    //   handleClose={openAccountCheck.disable}
    //   iconSrc={`${publicRuntimeConfig.STRAPI_SERVER}${cmsData?.attributes?.EirImages_OrderSummary?.EirImages[0]?.Logo?.data?.attributes?.url}`}
    //   title='Add another SIM Only plan?'
    //   description='No Limits 5G Data + Unlimited Calls & Texts + 30GB EU Roaming'
    //   cta={[
    //     { text: 'SIM only', type: 'contained', action: () => handleYes() },
    //     { text: 'No, go to checkout', type: 'contained', action: () => handleAltCta() },
    //   ]}
    //   disableCloseOnBackdropClick
    //   disableCloseOnEscapeKeyDown
    // />
  );
};

export default EirAddSimhandsetModal;
